// Badge component types for UI Component Library
// Created as part of ENG2-1691: Phase 3 - Ticket 3.1

export type StatusType = 'active' | 'trial' | 'expired' | 'inactive'
export type CountBadgeVariant = 'default' | 'primary'

export interface StatusBadgeProps {
  /** Status to display */
  status: StatusType
  /** Override the default label */
  label?: string
  /** Show colored dot indicator */
  showDot?: boolean
  /** Additional class name */
  className?: string
}

export interface CountBadgeProps {
  /** Number to display */
  count: number
  /** Visual variant */
  variant?: CountBadgeVariant
  /** Maximum number before showing "99+" */
  max?: number
  /** Additional class name */
  className?: string
}

// Default labels for each status
export const statusLabels: Record<StatusType, string> = {
  active: 'Active',
  trial: 'Trial',
  expired: 'Expired',
  inactive: 'Inactive',
}
